export const sites = {
  americanBlinds: 1,
  blindsCa: 2,
  blinds: 3,
  justBlinds: 5,
  theHomeDepot: 11,
};

export const itemTypes = {
  unknown: 0,
  window: 1,
  doorLock: 2,
  garageDoor: 3,
};

export const itemSources = {
  unknown: 0,
  autobahn: 1,
  theHomeDepot: 2,
};

export const containerTypes = {
  unknown: 0,
  room: 1,
  garage: 2,
};

